import React, { Component } from "react"
import "./GreenList.scss"
import _GreenData from "../../api/GreenList.json"
import GreenItem from "./GreenItem"

class GreenList extends Component {
    constructor() {
        super();
        this.state = {}
    }
    getList() {
        return _GreenData.map((item, index) => (index <= this.props.max && index >= this.props.index ? <GreenItem key={index} index={index} ID={index + 1} name={item.name} icon={item.icon} /> : null))
    }
    render() {
        return (
            <section className={`section section-greenlist ${this.props.className}`}>
                <div className="padding">
                    <div className={`container ${this.props.className}`}>
                        <div className="utils">
                            {this.getList()}
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default GreenList;


// WEBPACK FOOTER //
// ./src/Components/GreenList/GreenList.jsx